module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAbFBMVEUAAACu//+huv87hP89gf2Vuf07gPyXvv+Vuvw8gfs9g/+y0/89gf07gPw+g/yVuvyWuv09gvw+g/+Vuf07gPw8gfyWu/09gf2Xu/+Xu/+Atv+Uufw7gPtPjftYkvx3p/tqn/xDhfuGsPyFsPwQZg6GAAAAG3RSTlMAAgs4bf23GMGFKgfs39S8aVcj36OUbWlAMQ5s9fwiAAAAhklEQVQoz6XO2Q6DIBRFUVuLFnCodq5H0Pb//7EKcQqXxOh53CvhEiwWv2TgLn6cWZU79dLVfpKoZscpv3NTXbia4MKh2gkfHyT3cA6NUqoxkAEpFyO0AFp7Q/AUKAf4aq1/FrrCEdK/Oq2AGkBt4XkraEiQ0U+JovTe2Axs3pkcIQK1yAt/wo0kssfqOBUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/qiye_small.png
// module id = lUxn
// module chunks = 36